export const parseCSV = (csvText) => {
  const lines = csvText.trim().split('\n');
  const headers = lines[0].split(',').map(header => header.trim());
  
  const data = [];
  for (let i = 1; i < lines.length; i++) {
    const values = [];
    let currentValue = '';
    let insideQuotes = false;
    
    for (let j = 0; j < lines[i].length; j++) {
      const char = lines[i][j];
      
      if (char === '"') {
        insideQuotes = !insideQuotes;
      } else if (char === ',' && !insideQuotes) {
        values.push(currentValue.trim());
        currentValue = '';
      } else {
        currentValue += char;
      }
    }
    values.push(currentValue.trim());
    
    if (values.length === headers.length) {
      const entry = {};
      headers.forEach((header, index) => {
        let value = values[index];
        
        if (header === 'id' || header === 'tradingCapital' || header === 'pnl') {
          value = parseInt(value) || 0;
        } else if (header === 'pnlPercentage') {
          value = parseFloat(value) || 0;
        } else if (value === '' || value === 'null' || value === 'undefined') {
          value = null;
        }
        
        entry[header] = value;
      });
      data.push(entry);
    }
  }
  
  return data;
};